export function forceReflow(element) {
    if (!element)
        return;
    void element.offsetWidth;
}
//# sourceMappingURL=dom.js.map